<ng-container *ngFor="let item of inlineItems; trackBy: trackByElementId" [ngSwitch]="item.kind">

  <a *ngSwitchCase="'link'" class="row-actions-control" [ngClass]="item.colorClass"
    [class.row-actions-control-disabled]="item.isDisabled"
    nz-tooltip nzTooltipPlacement="top" [nzTooltipTitle]="item.tooltip || item.label"
    [attr.aria-label]="item.label" [attr.aria-disabled]="item.isDisabled" [attr.tabindex]="item.isDisabled ? -1 : 0"
    [routerLink]="item.isDisabled ? null : item.routerLink"
    (click)="item.isDisabled ? $event.preventDefault() : $event.stopPropagation()"
    [id]="item.elementId" [attr.data-testid]="item.elementId">
    <fa-icon [icon]="item.icon" [fixedWidth]="true"></fa-icon>
  </a>

  <button *ngSwitchCase="'confirm'" type="button" class="row-actions-control" [ngClass]="item.colorClass"
    [disabled]="item.isDisabled"
    nz-popconfirm nzPopconfirmPlacement="left" [nzPopconfirmTitle]="inlineConfirmTitleTpl" [nzOkText]="item.confirmOkText"
    (nzOnConfirm)="onSelect(item)"
    nz-tooltip nzTooltipPlacement="top" [nzTooltipTitle]="item.tooltip || item.label"
    [attr.aria-label]="item.label"
    (click)="$event.stopPropagation()"
    [id]="item.elementId" [attr.data-testid]="item.elementId">
    <fa-icon [icon]="item.icon" [fixedWidth]="true"></fa-icon>
  </button>
  <ng-template #inlineConfirmTitleTpl>
    <fa-icon icon="exclamation-circle" class="font-icon-color-warning-mid-dark margin-right-small"></fa-icon>
    {{item.confirmDescription}}
  </ng-template>

  <button *ngSwitchCase="'click'" type="button" class="row-actions-control" [ngClass]="item.colorClass"
    [disabled]="item.isDisabled"
    nz-tooltip nzTooltipPlacement="top" [nzTooltipTitle]="item.tooltip || item.label"
    [attr.aria-label]="item.label"
    (click)="$event.stopPropagation(); onSelect(item)"
    [id]="item.elementId" [attr.data-testid]="item.elementId">
    <fa-icon [icon]="item.icon" [fixedWidth]="true"></fa-icon>
  </button>

</ng-container>

<button *ngIf="menuItems.length" #trigger type="button"
  class="row-actions-control font-icon-color-grey-cool font-icon-hover-color-primary-black"
  [class.row-actions-trigger-open]="isMenuOpen"
  nz-dropdown nzTrigger="click" nzPlacement="bottomRight" [nzDropdownMenu]="rowActionsMenu"
  [nzClickHide]="false" [nzVisible]="isMenuOpen" (nzVisibleChange)="onMenuVisibleChange($event)"
  nz-tooltip nzTooltipPlacement="top" nzTooltipTitle="More Actions"
  aria-label="More actions" aria-haspopup="menu" [attr.aria-expanded]="isMenuOpen"
  (click)="$event.stopPropagation()"
  [id]="triggerId" [attr.data-testid]="triggerId">
  <fa-icon icon="ellipsis-v" [fixedWidth]="true"></fa-icon>
</button>

<nz-dropdown-menu #rowActionsMenu="nzDropdownMenu">
  <ul nz-menu class="row-actions-menu" role="menu" (keydown)="onMenuKeydown($event)"
    [id]="menuId" [attr.data-testid]="menuId">
    <ng-container *ngFor="let item of menuItems; trackBy: trackByElementId" [ngSwitch]="item.kind">

      <ng-container *ngSwitchCase="'confirm'">
        <li nz-menu-item class="row-actions-item"
          [class.row-actions-item-danger]="item.isDanger" [nzDisabled]="item.isDisabled"
          nz-popconfirm nzPopconfirmPlacement="left" [nzPopconfirmTitle]="confirmTitleTpl" [nzOkText]="item.confirmOkText"
          (nzOnConfirm)="onSelect(item)"
          nz-tooltip nzTooltipPlacement="right" [nzTooltipTitle]="item.tooltip"
          role="menuitem" [attr.tabindex]="item.isDisabled ? -1 : 0" [attr.aria-disabled]="item.isDisabled"
          (keydown.enter)="activateFocusedItem($event)" (keydown.space)="activateFocusedItem($event)"
          [id]="item.elementId" [attr.data-testid]="item.elementId">
          <fa-icon [icon]="item.icon" [fixedWidth]="true" class="row-actions-icon"></fa-icon>
          <span class="row-actions-label">{{item.label}}</span>
        </li>
        <ng-template #confirmTitleTpl>
          <fa-icon icon="exclamation-circle" class="font-icon-color-warning-mid-dark margin-right-small"></fa-icon>
          {{item.confirmDescription}}
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'link'">
        <li nz-menu-item class="row-actions-item"
          [nzDisabled]="item.isDisabled"
          nz-tooltip nzTooltipPlacement="right" [nzTooltipTitle]="item.tooltip"
          [id]="item.elementId" [attr.data-testid]="item.elementId">
          <a class="row-actions-link" [class.row-actions-control-disabled]="item.isDisabled"
            role="menuitem" [attr.tabindex]="item.isDisabled ? -1 : 0" [attr.aria-disabled]="item.isDisabled"
            [routerLink]="item.routerLink" (click)="closeMenu()">
            <fa-icon [icon]="item.icon" [fixedWidth]="true" class="row-actions-icon"></fa-icon>
            <span class="row-actions-label">{{item.label}}</span>
          </a>
        </li>
      </ng-container>

      <ng-container *ngSwitchCase="'click'">
        <li nz-menu-item class="row-actions-item"
          [class.row-actions-item-danger]="item.isDanger" [nzDisabled]="item.isDisabled" (click)="onSelect(item)"
          nz-tooltip nzTooltipPlacement="right" [nzTooltipTitle]="item.tooltip"
          role="menuitem" [attr.tabindex]="item.isDisabled ? -1 : 0" [attr.aria-disabled]="item.isDisabled"
          (keydown.enter)="activateFocusedItem($event)" (keydown.space)="activateFocusedItem($event)"
          [id]="item.elementId" [attr.data-testid]="item.elementId">
          <fa-icon [icon]="item.icon" [fixedWidth]="true" class="row-actions-icon"></fa-icon>
          <span class="row-actions-label">{{item.label}}</span>
        </li>
      </ng-container>

    </ng-container>
  </ul>
</nz-dropdown-menu>
